import { Card, Dialog, DialogActions, DialogContent, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { MediaListItem } from 'components/common/MediaListItem';
import { TrackCover } from 'components/track/TrackCover';
import { useUser } from 'hooks/useUser';
import { TrackRequest } from 'models/TrackRequest';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isRequestTypeTrack } from 'utils/isRequestTypeTrack';

export interface RequestMessageDialogProps {
  request: TrackRequest;
  open: boolean;
  onClose?: () => void;
  onSave?: (message: string) => void;
}

export function RequestMessageDialog({
  request,
  open,
  onClose,
  onSave,
}: RequestMessageDialogProps) {
  const { t } = useTranslation();
  const { requesterId } = useUser();
  const title = isRequestTypeTrack(request.value) ? request.value.title : request.value;
  const artist = isRequestTypeTrack(request.value) ? request.value.artist : undefined;

  const requesterMessage = request.messages?.find((message) => message.id == requesterId);
  const [value, setValue] = useState(requesterMessage?.value ?? '');

  const handleCloseDialog = () => {
    onClose?.();
  };

  const handleSaveMessage = async (message: string) => {
    onSave?.(message);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Card elevation={2} sx={{ mb: 2, py: 0.5 }}>
          <MediaListItem
            size="small"
            media={
              isRequestTypeTrack(request.value) ? (
                <TrackCover title={title} cover={request.value.artworkUrl} size="small" />
              ) : (
                <TrackCover title={title} size="small" />
              )
            }
            title={title}
            subtitle={artist}
          />
        </Card>
        <TextField
          label={t('yourMessage', 'You message')}
          variant="outlined"
          multiline
          value={value}
          minRows={2}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setValue(event.target.value);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleCloseDialog}>
          {t('cancel', 'Cancel')}
        </Button>
        <Button variant="contained" onClick={() => handleSaveMessage(value)} color="primary">
          {t('save', 'Save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
